<mat-card>
  <mat-card-header
    ><h4>{{ title }}</h4></mat-card-header
  >
  <mat-card-content>
    <form #searchForm="ngForm" (ngSubmit)="search()">
      <ng-container *ngFor="let filter of filters">
        <ng-container [ngSwitch]="filter.type">
          <mat-form-field appearance="outline" *ngSwitchCase="'text'">
            <input
              matInput
              [placeholder]="filter.label"
              type="text"
              id="{{ filter.paramName }}"
              name="{{ filter.paramName }}"
              [(ngModel)]="filter.value"
              autocomplete="off"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" *ngSwitchCase="'number'">
            <input
              matInput
              [placeholder]="filter.label"
              type="number"
              id="{{ filter.paramName }}"
              name="{{ filter.paramName }}"
              [(ngModel)]="filter.value"
              autocomplete="off"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" *ngSwitchCase="'checkbox'">
            <input
              matInput
              [placeholder]="filter.label"
              type="checkbox"
              id="{{ filter.paramName }}"
              name="{{ filter.paramName }}"
              [(ngModel)]="filter.value"
              autocomplete="off"
            />
          </mat-form-field>
          <mat-form-field id="filter-button-{{ filter.paramName }}" appearance="outline" *ngSwitchCase="'date'" (click)="datePicker.open()">
            <input
              matInput
              [matDatepicker]="datePicker"
              id="{{ filter.paramName }}"
              name="{{ filter.paramName }}"
              [(ngModel)]="filter.value"
              (dateChange)="handleDatePickerChange(filter, $event)"
            />
            <mat-icon matSuffix class="material-icons-two-tone">calendar_today</mat-icon>
            <mat-datepicker #datePicker disabled="false"></mat-datepicker>
            <button type="button" mat-icon-button matSuffix *ngIf="filter.value && filter.type !== 'date'" (click)="clearFilter(filter)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </ng-container>
      </ng-container>
      <button id="filter-button-search" mat-raised-button type="submit" [disabled]="searchForm.form.pristine" color="primary">
        Search
      </button>
    </form>
  </mat-card-content>
</mat-card>
